module.exports = __webpack_public_path__ + "assets/copy-scene-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/copy-scene-icon.svg
// module id = 326
// module chunks = 0